// extracted by mini-css-extract-plugin
export default {"root":"sIoBB44m","image":"iXU+aDg2"};